/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.commercialSCTP = (await import('./pages/CommercialSaveCardToProfile')).CommercialSaveCardToProfile;
    Components.SCTP = (await import('./pages/SaveCardToProfile')).SaveCardToProfile;
    Components.ECM = (await import('./pages/ECMSaveCard')).ECMSaveCard;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages = {}) => ({
  commercialSCTP: {
    name: 'CommercialSaveCardToProfile',
    componentName: 'CommercialSaveCardToProfile',
    chunk: () => import('./pages/CommercialSaveCardToProfile'),
    get component() {
      return ssr
        ? serverPages.commercialSCTP
        : currentRouteName === 'CommercialSaveCardToProfile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.CommercialSaveCardToProfile })));
    },
    path: '/:context?/:myaccount?/commercialsavecardtoprofile',
    channel: null
  },
  SCTP: {
    name: 'SaveCardToProfile',
    componentName: 'SaveCardToProfile',
    chunk: () => import('./pages/SaveCardToProfile'),
    get component() {
      return ssr
        ? serverPages.SCTP
        : currentRouteName === 'SaveCardToProfile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.SaveCardToProfile })));
    },
    path: '/:context?/:myaccount?/savecardtoprofile',
    channel: null
  },
  ECM: {
    name: 'ECMSaveCard',
    componentName: 'ECMSaveCard',
    chunk: () => import('./pages/ECMSaveCard'),
    get component() {
      return ssr
        ? serverPages.ECM
        : currentRouteName === 'ECMSaveCard'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ECMSaveCard })));
    },
    path: '/:context?/:myaccount?/ecmsavecard',
    channel: null
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  },
});
